// import React, { useState } from "react";
// import Navbar from "./global-components/navbar";
// import Footer from "./global-components/footer";

// const LoadCalculator = () => {
//      const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(false);
//   return (
    
//     <div>
//       <Navbar />
//      <iframe
//         src="http://localhost:9002/"
//         width="100%"
//         height="850px"
//         frameBorder="0"
//         title="Solar Panel Calculator"
//         scrolling="no"
//         allowFullScreen
      
         
//       ></iframe>
    
//       <Footer />
//     </div>
//   );
// };

// export default LoadCalculator;

// import React, { useState,useEffect, useRef } from "react";
// import Navbar from "./global-components/navbar";
// import Footer from "./global-components/footer";


// export default function CalculatorPage() {
//   return (
//     <div className="d-flex flex-column min-vh-100">
//       <Navbar />

//       <div className="flex-grow overflow-hidden">
//         <iframe
//           src="https://atom-power-load-calculator.surge.sh/"
//           title="Solar Panel Calculator"
//           width="100%"
//           style={{ height: 'calc(100vh - 200px)' }}
//           frameBorder="0"
//           scrolling="no"
//           allowFullScreen
//           className="w-100 border-0"
//         ></iframe>
//       </div>

//       <Footer />
//     </div>
//   );
// }


// New Code
import React, { useEffect, useRef, useState } from "react";
import Navbar from "./global-components/navbar";
import Footer from "./global-components/footer";

export default function CalculatorPage() {
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState("650px");
  const iframeSrc = window.appconfig.SOLAR_CALCULATOR_IFRAME_SRC;
  

  // useEffect(() => {
  //   const handleMessage = (event) => {
  //     if (event.data?.type === "iframe-resize" && event.data?.height) {
        
  //       console.log(event.data.height,"arham");
  //       setIframeHeight(`${event.data.height}px`);
  //     }
  //   };

  //   window.addEventListener("message", handleMessage);
  //   return () => window.removeEventListener("message", handleMessage);
  // }, []);
  useEffect(() => {
  const handleMessage = (event) => {
    if (event.data?.type === "iframe-resize" && event.data?.height) {
      const newHeight = `${event.data.height}px`;

      // ✅ Ignore same value
      setIframeHeight((prevHeight) => {
        if (prevHeight !== newHeight) {
          console.log("Setting new height:", newHeight);
          return newHeight;
        }
        return prevHeight;
      });
    }
  };

  window.addEventListener("message", handleMessage);
  return () => window.removeEventListener("message", handleMessage);
}, []);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <Navbar />

      {/* Dynamic Iframe */}
      <iframe
        ref={iframeRef}
        src={iframeSrc}
        title="Solar Calculator"
        style={{
          width: "100%",
          height: iframeHeight,
          border: "none",
          transition: "height 0.3s ease-in-out",
        }}
        scrolling="no"
      />

      <Footer />
    </div>
  );
}
